var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qrcode-container" },
    [
      _c("div", {
        ref: "qrcode",
        staticClass: "qrcode-wrapper",
        on: { click: _vm.showPreview },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "二维码预览",
            visible: _vm.previewVisible,
            width: "400px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "preview-container" },
            [
              _c("div", {
                ref: "previewQrcode",
                staticClass: "preview-qrcode",
              }),
              _vm._v(" "),
              _c("p", { staticClass: "qrcode-url" }, [_vm._v(_vm._s(_vm.url))]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticStyle: { "margin-top": "15px" },
                  attrs: { type: "primary" },
                  on: { click: _vm.openUrl },
                },
                [_vm._v("\n        打开链接\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }